import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Field } from "formik";
import { Input } from "components/bootstrap";
const DirectionOptions = styled.div`
  display: flex;

  .radio {
    padding-top: 6px;
  }

  div:first-child {
    margin-right: 5px;
  }
`;
const WidgetModeConfiguration = ({ name, onChange: onChangeProp, options }) => {
  const { t } = useTranslation("widgets");
  return /* @__PURE__ */ React.createElement(Field, { name }, ({ field: { value, onChange, onBlur }, meta: { error } }) => {
    const handleChange = (event) => {
      onChangeProp(event.target.value);
      onChange(event);
    };
    return /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "widget-type-configuration",
        label: t("overview_configuration.type"),
        error,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      },
      /* @__PURE__ */ React.createElement(DirectionOptions, null, options.map(({ value: optionValue, label }) => /* @__PURE__ */ React.createElement(
        Input,
        {
          checked: value === optionValue,
          key: optionValue,
          formGroupClassName: "",
          id: name,
          label,
          onBlur,
          onChange: handleChange,
          type: "radio",
          value: optionValue
        }
      )))
    );
  });
};
export default WidgetModeConfiguration;
